import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { rutaOperacion } from '../_operacion.js';

/** Las ventas de Umashi, debajo de Efectivo, para el operario y el jefe. Adjudicación 300. */
export const rutaVentasUmashi = createRoute({
  getParentRoute: () => rutaOperacion,
  path: '/ventas-umashi',
  component: lazyRouteComponent(() => import('./ventas-umashi-pantalla.js'), 'RutaVentasUmashi'),
});
